import { Type } from 'class-transformer';
import { Input, EventEmitter, Output, Directive } from "@angular/core";
import { DataDescriptionRelational } from "./relational/datadescriptionrelational.model";
import { DataDescription } from "./multi/datadescription.model";
import { UUID } from "angular2-uuid";
import { TranslatedString } from '../translatedstring.model';




@Directive()
export class DatadescriptionData {
  //@Type(() => WorkflowModuleData)
  //Modules: WorkflowModuleData[] = [];
  //@Type(() => WorkflowConnectorData)
  //Connectors: WorkflowConnectorData[] = [];

  Datadescription: any = new DataDescriptionRelational();
  DataModelID: UUID;
  IsRelationalValue = true;


  @Input()
  get IsRelational() {
    return this.IsRelationalValue;
  }
  set IsRelational(val) {
    if (!this.Datadescription) {
      this.Datadescription = this.IsRelationalValue ? new DataDescriptionRelational() : new DataDescription();
      this.IsRelationalChange.emit(val);
    }
    else {
      if (val === false && this.Datadescription instanceof DataDescriptionRelational ||
        val === true && this.Datadescription instanceof DataDescription) {
          this.Datadescription = val ? new DataDescriptionRelational() : new DataDescription();
          this.IsRelationalChange.emit(val);
      }

      this.IsRelationalValue = val;
    }
  }



  @Output() IsRelationalChange = new EventEmitter<any>();


  
}

// @dynamic
@Directive()
export class DatadescriptionSaveObject extends DatadescriptionData {
  @Type(() => TranslatedString)
  Caption: TranslatedString;
  @Type(() => TranslatedString)
  Description: TranslatedString;
}

